<template>
  <div>
    <v-row justify="center">
      <v-dialog
        :value="true"
        persistent
        @click:outside="$emit('close')"
        max-width="400px"
      >
        <v-card>
          <v-card-title>
            <span class="text-subtitle bold pa-4">Edit Paymodel</span>
            <v-spacer class="spacer-paymodel"></v-spacer>
            <v-icon
              class="mr-2"
              @click="$emit('close')"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-divider
            class="ml-8"
            width="90%"
          ></v-divider>
          <div class="pa-4">            
            <v-text-field
              class="px-6"
              v-model="editPaymodel.name"
              placeholder="Enter tag"
              background-color="#F8F9FB"
              dense
              solo
              flat
            ></v-text-field>
          </div>      
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              class="addButton pa-6 mb-6 mr-6 white--text"
              color="tvf_color"
              @click="editedPaymodel"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";

export default {
  props: ['editPaymodel'],
  data() {
    return {
      errors: [],
    };
  },

  methods: {

    async editedPaymodel() {
      this.errors = [];

      await ApiService.put("paymodels/" + this.editPaymodel.id, {
        name: this.editPaymodel.name,
      })
        .then((response) => {
          console.log("Submit Success");
          this.$emit('close');
          this.$emit('updateList');
          this.$store.dispatch('setSnackbar', {
            color: 'success',
            text: 'Paymodel has been updated succesfully!',
            timeout: 3000
          })
        }).catch((error) => {
            if (typeof error.response.data === 'object') {
            this.$store.dispatch('setSnackbar', {
            color: 'tvf_secondary',
            text: error.response.data.errors.name[0]
            })
            }
        });
    },
  }
};
</script>

<style scoped>
.col-sm-4,
.col-md-4,
.col-12,
.col-sm-8,
.col-md-8 {
  padding: 0px;
}

.v-sheet .v-card__title .spacer-paymodel {
    width: 0;
}

</style>